import FormattedMessage from 'I18n/components/FormattedMessage';
import { MatchRateCard } from './MatchRateCard';
import { useEnrichableObjectTypes } from '../../EnrichableObjectTypesProvider/EnrichableObjectTypeProvider';
import { jsx as _jsx } from "react/jsx-runtime";
export const MatchRateCardEligible = ({
  count,
  isContactEnrichment,
  isLoading
}) => {
  const {
    companyLabel,
    companyLabelPlural,
    contactLabel,
    contactLabelPlural
  } = useEnrichableObjectTypes();
  if (isContactEnrichment) {
    return /*#__PURE__*/_jsx(MatchRateCard, {
      count: count,
      isLoading: isLoading,
      tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "dataTest.matchRate.contacts.eligibleTooltip",
        options: {
          objectType: contactLabelPlural
        }
      }),
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "dataTest.matchRate.contacts.eligible",
        options: {
          objectType: count === 1 ? contactLabel : contactLabelPlural
        }
      })
    });
  }
  return /*#__PURE__*/_jsx(MatchRateCard, {
    count: count,
    isLoading: isLoading,
    tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "dataTest.matchRate.companies.eligibleTooltip",
      options: {
        objectType: companyLabelPlural
      }
    }),
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "dataTest.matchRate.companies.eligible",
      options: {
        objectType: count === 1 ? companyLabel : companyLabelPlural
      }
    })
  });
};